<template>
  <v-row>
    <v-col class="ma-0 pt-2 pb-1" cols="12" v-if="attributeType == 'MULTI'">
      <v-select
        :disabled="readOnly"
        v-model="selectInput"
        :items="attribute.multiChoiceItems"
        :label="attribute.name"
        dense=""
        hide-details
        multiple
        v-on:change="ValueChanged()"
        item-text="name"
        item-color="white"
        return-object
        :clearable="!readOnly"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip small v-if="index < 3">
            <span>{{ item.name }}</span>
          </v-chip>
          <span v-if="index === 3" class="grey--text caption"
            >(+{{ selectInput.length - 1 }} others)</span
          >
        </template>
      </v-select>
    </v-col>
    <v-col class="ma-0 pt-2 pb-1" cols="12" v-if="attributeType == 'STRING'">
      <v-text-field
        :disabled="readOnly"
        v-model="textInput"
        :label="attribute.name"
        dense
        hide-details=""
        placeholder=" "
        v-on:change="ValueChanged()"
        :append-outer-icon="showDelete ? 'mdi-delete' : ''"
        @click:append-outer="OnRemoveField"
      ></v-text-field>
    </v-col>
    <v-col class="ma-0 pt-2 pb-1" cols="12" v-if="attributeType == 'NUMERIC'">
      <v-text-field
        :disabled="readOnly"
        v-model="textInput"
        :label="attribute.name"
        dense
        hide-details=""
        placeholder=" "
        v-on:change="ValueChanged()"
        :append-outer-icon="showDelete ? 'mdi-delete' : ''"
        @click:append-outer="OnRemoveField"
      ></v-text-field>
    </v-col>
    <v-col
      class="ma-0 pt-2 pb-1"
      cols="12"
      v-if="attributeType == 'ASSETARRAY'"
    >
      <v-combobox
        v-if="showComboBox"
        ref="combobox"
        :disabled="readOnly || isCategoryAtbVal"
        v-model="selectInput"
        :items="loadedItems"
        hide-selected
        hide-details=""
        dense
        v-on:focus="OnFocus()"
        v-on:change="ValueChanged()"
        :search-input.sync="searchFilter"
        :label="attribute.name"
        multiple=""
        item-text="name"
        :clearable="!isCategoryAtbVal && !readOnly"
        chips=""
        :append-outer-icon="showDelete && !isCategoryAtbVal ? 'mdi-delete' : ''"
        @click:append-outer="OnRemoveField"
      >
        <template v-slot:no-data>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title v-if="isLoaded">
                <span v-if="allowNewItems"
                  >No results matching "<strong>{{ searchFilter }}</strong
                  >". Press <kbd>enter</kbd> to create a new one</span
                >
                <span v-else
                  >No results matching "<strong>{{ searchFilter }}</strong
                  >".</span
                >
              </v-list-item-title>
              <v-progress-circular
                style="pointer-events:none"
                indeterminate=""
                v-else
              ></v-progress-circular>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template v-slot:selection="{ item, index }">
          <v-chip medium>
            <span>{{ item.name }}</span>
            <v-btn
              @click.stop="OnClickAttributeLink(item.id)"
              small
              text
              color="blue"
              class="ml-0 mr-0 pl-0 pr-0"
              ><v-icon>mdi-link-variant</v-icon></v-btn
            >
          </v-chip>
        </template>
      </v-combobox>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import CONFIG from "../../appconfig.json";
import { GetAuthorisationHeaderGroup } from "../../vuex/assetxphelpers.js";

export default {
  name: "AttributeField",
  props: {
    isSearchAttribute: {
      default: false,
      type: Boolean,
    },
    searchSectionId: {
      default: null,
      type: String,
    },
    // Used for forcibly update attribute
    forceLoader: {
      default: 0,
      type: Number,
    },
    //Sets the field to no accept input
    readOnly: {
      default: false,
      type: Boolean,
    },
    //Shows the delete option to clear the field
    showDelete: {
      default: false,
      type: Boolean,
    },
    //Attribute to act as as the model for this input
    attribute: {
      default: {},
      type: Object,
    },
    //Assigned assetid
    assetid: {
      default: "",
      type: String,
    },
    //The active categories to scope by, this helps us filter to real values used within a contenxt, not all of them.
    categories: {
      default: null,
      type: Array,
    },
    //Alow new items to be added
    allowNewItems: {
      default: false,
      type: Boolean,
    },
    //Default items to assign as values
    defaultItems: {
      default: null,
      type: Object,
    },
    initalValues: {
      default: null,
      type: Array,
    },
    cascadingAttributes: {
      default() {
        return [];
      },
      type: Array,
    },
  },
  computed: {
    isCategoryAtbVal() {
      if (this.attribute != null && !this.isSearchAttribute) {
        return this.attribute.name.toLowerCase() == "ixpcategory";
      } else {
        return false;
      }
    },
    attributeType() {
      if (this.attribute.attributeType == 0) {
        return "MULTI";
      } else if (this.attribute.attributeType == 1) {
        return "STRING";
      } else if (this.attribute.attributeType == 2) {
        return "NUMERIC";
      } else if (this.attribute.attributeType == 3) {
        return "ASSETARRAY";
      }

      return "";
    },
  },
  data: () => ({
    searchFilter: "",
    textInput: "",
    selectInput: [],
    isLoading: false,
    isLoaded: false,
    loadedItems: [],
    prevEventObj: null,
    showComboBox: true,
  }),
  mounted: function() {
    if (this.assetid != null) {
      if (this.attributeType != "ASSETARRAY") {
        this.$data.isLoaded = true;
      }
    }

    if (this.initalValues != null) {
      this.selectInput = [];
      for (let i = 0; i < this.initalValues.length; i++) {
        this.selectInput.push({
          id: this.initalValues[i].id,
          name: this.initalValues[i].name,
        });
      }
    }
  },
  methods: {
    OnClickAttributeLink(listingId) {
      console.log("Tapping link", listingId);
      axios
        .get(
          CONFIG.platformEndpoints.assetxpapi + "asset/getlisting/" + listingId,
          GetAuthorisationHeaderGroup()
        )
        .then((response) => {
          console.log("Got link tap response", response.data);

          let detailid = response.data.assetDetailid;
          let url = window.location.origin + "/#/asset/" + detailid;
          window.open(url);
        });
    },
    OnRemoveField() {
      this.$emit("RemoveAttribute", this.$props.attribute);
    },
    OnFocus() {
      if (!this.$data.isLoaded || this.assetid == null) {
        this.LoadNext(this.assetid != null);
      }
    },
    LoadNext(isAssetPage) {
      this.$data.isLoaded = false;
      this.$data.isLoading = true;
      this.$data.loadedItems = [];

      var catList = new Array();

      if (this.$props.categories != null) {
        for (let i = 0; i < this.$props.categories.length; i++) {
          catList.push(this.$props.categories[i].id);
        }
      }

      let atbSendList = [];

      for (let x = 0; x < this.$props.cascadingAttributes.length; x++) {
        const element = this.$props.cascadingAttributes[x];

        atbSendList.push({
          id: element.id,
          vals: element.values,
        });
      }

      var postObj = {
        text: this.$data.searchFilter,
        categories: catList,
        attributeid: this.$props.attribute.id,
        catFilters: this.$props.attribute.catFilters,
        sectionFilters: this.$props.attribute.sectionFilters,
        onlyGetAssignedValues: true,
        cascadingAttributeValues: atbSendList,
        sectionid: this.$props.searchSectionId,
      };

      console.log("Sending cascading attributes", atbSendList);

      console.log("Props", this.$props);
      console.log("Posting");
      console.log(postObj);
      console.log(this.$props.attribute);

      axios
        .post(
          CONFIG.platformEndpoints.assetxpapi + "attribute/searchdropdown",
          postObj,
          GetAuthorisationHeaderGroup()
        )
        .then((response) => {
          console.log("Loading next");
          console.log(response.data);

          this.$data.loadedItems = response.data;
          this.$data.isLoading = false;
          this.$data.isLoaded = true;
        });
    },
    ValueChanged() {
      console.log("Value changed");

      if (!this.allowNewItems) {
        var newArray = new Array();

        for (let i = 0; i < this.selectInput.length; i++) {
          if (this.selectInput[i] === Object(this.selectInput[i])) {
            newArray.push(this.selectInput[i]);
          }
        }

        this.selectInput = newArray;
      }

      if (this.attributeType == "ASSETARRAY") {
        var selectedNames = this.selectInput
          .filter(function(item) { return item === Object(item) && item.name; })
          .map(function(item) { return item.name.toLowerCase(); });

        if (selectedNames.length > 0) {
          this.selectInput = this.selectInput.filter(function(item) {
            if (typeof item === "string") {
              var lower = item.toLowerCase();
              return !selectedNames.some(function(name) {
                return name.startsWith(lower);
              });
            }
            return true;
          });
        }

        this.$nextTick(function() {
          this.searchFilter = "";
        }.bind(this));
      }

      var eventObj = {
        attribute: this.$props.attribute,
      };

      if (this.attributeType == "MULTI") {
        let items = new Array();
        for (let i = 0; i < this.selectInput.length; i++) {
          items.push(this.selectInput[i]);
        }

        eventObj.values = items;
      } else if (this.attributeType == "ASSETARRAY") {
        let items = new Array();
        let names = new Array();
        for (let i = 0; i < this.selectInput.length; i++) {
          if (this.selectInput[i].id != null) {
            items.push(this.selectInput[i].id);
            names.push(this.selectInput[i].name);
          } else {
            items.push(this.selectInput[i]);
          }
        }

        eventObj.values = items;
        eventObj.names = names;
      } else if (
        this.attributeType == "STRING" ||
        this.attributeType == "NUMERIC"
      ) {
        if (this.prevEventObj != null) {
          if (this.prevEventObj.values[0] == this.textInput) return;
        }

        eventObj.values = [this.textInput];
      }

      this.prevEventObj = eventObj;
      this.$emit("OnChanged", eventObj);
      this.$emit("attributeValueChanged", {
        id: eventObj.attribute.id,
        attributeType: eventObj.attribute.attributeType,
        textInput: this.textInput,
        selectInput: this.selectInput,
        attributeValues:
          this.selectInput.length === 0
            ? [this.textInput]
            : this.selectInput.map((a) => a.name),
      });
    },
  },
  watch: {
    categories: {
      handler(newVal) {
        this.$data.isLoaded = false;
      },
    },
    attribute: {
      handler(newAttr) {
        if (this.attributeType == "MULTI") {
          this.selectInput = newAttr.selectedMultiChoice || [];
        } else if (this.attributeType == "NUMERIC") {
          this.textInput = newAttr.value;
        } else if (this.attributeType == "STRING") {
          this.textInput = newAttr.value;
        } else if (this.attributeType == "ASSETARRAY") {
          this.selectInput = newAttr.selectedItems || newAttr.selectInput || [];
        }
      },
    },
    assetid: {
      immediate: true,
      handler(newVal) {
        if (this.attributeType == "MULTI") {
          this.selectInput = this.attribute.selectedMultiChoice;
        } else if (this.attributeType == "NUMERIC") {
          this.textInput = this.attribute.value;
        } else if (this.attributeType == "STRING") {
          this.textInput = this.attribute.value;
        } else if (this.attributeType == "ASSETARRAY") {
          this.selectInput = this.attribute.selectedItems;
        }
      },
    },
    defaultItems: {
      immediate: true,
      handler(newVal) {
        if (newVal == null) return;

        if (newVal.attributeType == 3) {
          this.selectInput = [];

          for (let i = 0; i < newVal.values.length; i++) {
            this.selectInput.push({
              id: newVal.values[i],
              name: newVal.names[i],
            });
          }
        }
      },
    },
    initalValues: {
      immediate: true,
      handler(newVal) {},
    },
  },
};
</script>

<style></style>
